module.exports = __webpack_public_path__ + "static/media/x-squad.8108737f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x-squad.png
// module id = 1640
// module chunks = 0